import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../shared/Navbar';
import './LandingPage.css';
import './UniversityPage.css';
import { LearningChatMessage, LearningNav, LearningHero, HowItWorks, LearningFooter } from './LearningPageSections';
import { universityAreas } from '../../utils/universityCatalogue';

const exampleMessages: readonly LearningChatMessage[] = [
  {
    role: 'tutor',
    content: 'A firm raises its price and sells fewer units, but its revenue rises. What does that tell you about demand?',
  },
  {
    role: 'student',
    content: 'Demand is price inelastic.',
  },
  {
    role: 'tutor',
    content: 'Yes. The percentage fall in quantity is smaller than the percentage rise in price. What would you look at next to test that claim?',
  },
];

export default function UniversityPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'University Learning | TeachMeNow';
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="lp-root learning-page university-page">
      <Navbar />
      <LearningNav />
      <main>
        <LearningHero
          lessonTitle="Economics · Demand"
          messages={exampleMessages}
          title="University courses, taught one question at a time."
          description="Prepared university courses in computer science, economics, finance, and management, art, and English literature. Work through the lessons with an AI tutor that explains the idea, asks you to try it, and helps you from your answer."
        >
          <a className="tm-button tm-button--primary" href="#university-subjects">Choose a subject <span aria-hidden="true">→</span></a>
          <a className="tm-button tm-button--secondary" href="#how-it-works">How it works</a>
        </LearningHero>
        <section className="learning-section tm-shell" id="university-subjects" aria-labelledby="university-subjects-title">
          <div className="learning-section-heading">
            <h2 id="university-subjects-title">Choose a subject</h2>
            <p>Open a subject to see the university courses in that area, then choose a course.</p>
          </div>
          <div className="university-subject-grid">
            {universityAreas.map(area => (
              <Link className={`university-subject-card university-subject-card--${area.className}`} to={`/university/${area.slug}`} key={area.slug}>
                <span className="university-subject-icon" aria-hidden="true">
                  <svg viewBox="0 0 48 48"><path d={area.iconPath} /></svg>
                </span>
                <span className="university-subject-copy">
                  <h3>{area.name}</h3>
                  <span>{area.detail}</span>
                </span>
                <span className="university-subject-arrow" aria-hidden="true">→</span>
              </Link>
            ))}
          </div>
        </section>
        <HowItWorks />
      </main>
      <LearningFooter />
    </div>
  );
}
